/**
 * AutoGlow · Advisor · WidgetCard layout primitive.
 * Used by every widget · provides title, description, citations, content area.
 */
import React from "react";
import { CitationBadge } from "./Badges";

export function WidgetCard({
  title,
  description,
  citations,
  children,
  actions,
  className = "",
  testId,
}) {
  return (
    <section
      data-testid={testId || "widget-card"}
      className={`rounded-lg border border-[var(--ag-border)] bg-[var(--ag-surface)] p-4 ${className}`}
    >
      {(title || actions) && (
        <header className="mb-3 flex items-start justify-between gap-2">
          <div>
            {title && (
              <h3 className="text-sm font-semibold text-[var(--ag-text)]">
                {title}
              </h3>
            )}
            {description && (
              <p className="mt-0.5 text-xs text-[var(--ag-text-dim)]">{description}</p>
            )}
          </div>
          {actions && <div className="flex shrink-0 items-center gap-1">{actions}</div>}
        </header>
      )}
      <div>{children}</div>
      {citations && citations.length > 0 && <CitationBadge sources={citations} />}
    </section>
  );
}

export function WidgetGrid({ children, cols = "lg:grid-cols-3", className = "" }) {
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 ${cols} gap-3 ${className}`}>
      {children}
    </div>
  );
}
